import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Github, ShieldCheck, Sun, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <h3>JustLabs</h3>
            <p>
              An independent software product company. We design, engineer, and publish high-utility Android applications and specialized commercial tools built for speed, simplicity, and offline privacy.
            </p>
            <div className="footer-legal-badge">
              <ShieldCheck size={16} />
              <span>Legal Entity: <strong>Pankaj Acharya</strong> (Sole Proprietor)</span>
            </div>
            <div className="social-links">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <Github size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Software Products</h4>
            <div className="footer-links">
              <Link to="/justsolar" className="footer-highlight-link">
                <Sun size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                JustSolar (EPC Software)
              </Link>
              <a href="https://play.google.com/store/apps/details?id=com.justlabs.justpdf" target="_blank" rel="noopener noreferrer">Image to PDF - JustPDF</a>
              <a href="https://play.google.com/store/apps/details?id=com.justlabs.justprint" target="_blank" rel="noopener noreferrer">JustPrint - Printable Notes</a>
              <a href="https://play.google.com/store/apps/details?id=com.justlabs.justsaver" target="_blank" rel="noopener noreferrer">Status Saver - JustSaver</a>
              <a href="https://play.google.com/store/apps/details?id=com.justlabs.justconverter" target="_blank" rel="noopener noreferrer">JPG to PNG - JustConverter</a>
              <a href="https://play.google.com/store/apps/dev?id=5490381095417506124&hl=en_IN" target="_blank" rel="noopener noreferrer" className="footer-highlight-link">
                Google Play Store Profile <ExternalLink size={12} style={{ marginLeft: '2px', verticalAlign: 'middle' }} />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Legal & Policies</h4>
            <div className="footer-links">
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
              <Link to="/refund-cancellation-policy">Refund & Cancellation Policy</Link>
              <Link to="/privacypolicy">Privacy Policy</Link>
              <Link to="/data-deletion">User Data Deletion</Link>
              <Link to="/contact-us">Contact Us & Merchant Details</Link>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>App Privacy Policies</h4>
            <div className="footer-links">
              <Link to="/justsolar_privacypolicy" className="footer-highlight-link">
                JustSolar Privacy Policy
              </Link>
              <Link to="/justpdf_privacypolicy">JustPDF Privacy Policy</Link>
              <Link to="/justprint_privacypolicy">JustPrint Privacy Policy</Link>
              <Link to="/justsaver_privacypolicy">JustSaver Privacy Policy</Link>
              <Link to="/justconverter_privacy_policy">JustConverter Privacy Policy</Link>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} JustLabs. Owned and operated by <strong>Pankaj Acharya</strong>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;